export const getAgencyCallLogsUrl = () => 'agency/interactions';

export const getAgencyCallLogUrl = (id: number) => `agency/interactions/${id}`;

export const getAgencyAssociatedRecordsUrl = (interactionId: number, contactId: number) =>
  `agency/interactions/${interactionId}/contacts/${contactId}/integration_entities/contacts`;
